import { NgModule } from '@angular/core';
import { RootContainerComponent } from './root/components/root-container/root-container.component';
import { RootModule } from './root/root.module';
import { RouterModule, Routes, Router, NavigationEnd } from '@angular/router';
import { LoginComponent } from "./root/components/login/login.component";
import { RegisterComponent } from "./root/components/register/register.component";
import { VerifyComponent } from "./root/components/verify/verify.component";
import { ForgotPasswordComponent } from "./root/components/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./root/components/reset-password/reset-password.component";
import { ProfileComponent } from "./root/components/profile/profile.component";
import { AuthGuard } from "./home/guards/auth.guard";
import { TitleMetaService } from './root/services/title-meta.service';
import { filter } from 'rxjs/operators';
import { MobileProfileComponent } from './root/components/mobile-profile/mobile-profile.component';


const routes: Routes = [
	{
		path: '',
		component: RootContainerComponent,
		runGuardsAndResolvers: 'always',
		data: { title: 'Ausmit - Home', description: 'Welcome to Ausmit, your destination for premium jewellery.' },
		children: [
			{
				path: '',
				loadChildren: () =>
					import('./home/home.module').then((m) => m.HomeModule),
				data: { title: 'Ausmit - Home', description: 'Explore our exquisite jewellery collection.' }

			},
		],
	},
	{
		path: 'login',
		component: LoginComponent,
		data: { title: 'Login - Ausmit Jewellery', description: 'Sign in to access your account.' }
	},
	{
		path: 'register',
		component: RegisterComponent,
		data: { title: 'Register - Ausmit Jewellery', description: 'Create a new account to start shopping.' }
	},
	{
		path: 'verify',
		component: VerifyComponent,
		data: { title: 'Verify Account - Ausmit Jewellery', description: 'Verify your email address to complete registration.' }
	},
	{
		path: 'forgot-password',
		component: ForgotPasswordComponent,
		data: { title: 'Forgot Password - Ausmit Jewellery', description: "Reset your password if you've forgotten it." }
	},
	{
		path: 'reset-password/:emailId',
		component: ResetPasswordComponent,
		data: { title: 'Reset Password - Ausmit Jewellery', description: 'Create a new password for your account.' }
	},
	{
		path: 'profile',
		component: ProfileComponent,
		canActivate: [AuthGuard],
		data: { title: 'Profile - Ausmit Jewellery', description: 'View and manage your account profile.' }
	},
	{
		path: 'account',
		component: MobileProfileComponent,
		// canActivate: [AuthGuard],
		data: {
			title: 'Account Overview - Ausmit Jewellery',
			description: 'View your orders, wishlist, appointments, and other details in your account overview.'
		}
	},
	{
		path: '**',
		redirectTo: '',
		data: { title: '404 - Not Found', description: 'Page not found.' }
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			// scrollPositionRestoration: 'top',
			// relativeLinkResolution: 'legacy',
			onSameUrlNavigation: 'reload',
			scrollPositionRestoration: 'enabled',
			anchorScrolling: 'enabled',
		}),
		RootModule,
	],
	exports: [RouterModule],
})
export class AppRoutingModule {
	constructor(private router: Router, private titleMetaService: TitleMetaService) {
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe(() => {
			this.updateTitleAndDescription();
		});
	}
	private updateTitleAndDescription() {
		let route = this.router.routerState.root;
		while (route.firstChild) {
			route = route.firstChild;
		}
		const title = route.snapshot.data['title'];
		const description = route.snapshot.data['description'];
		if (title) {
			this.titleMetaService.setTitle(title);
		}
		if (description) {
			this.titleMetaService.setMetaDescription(description);
		}
	}
}
